import { NgModule } from '@angular/core';
import {CommonModule, DatePipe, NgOptimizedImage} from '@angular/common';
import {UserAvatarComponent} from "./user-avatar/user-avatar.component";
import {ProgressBarComponent} from "./progress-bar/progress-bar.component";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatTooltipModule} from "@angular/material/tooltip";
import {KeysPipe} from "../../pipes/keys.pipe";
import {FooterComponent} from "./footer/footer.component";
import {FooterResponsiveComponent} from "./footer-responsive/footer-responsive.component";
import {BlockUIModule} from "ng-block-ui";
import {WeaveLoaderComponent} from "../../shared/loaders/weave-loader/weave-loader.component";
import {MatMenuModule} from "@angular/material/menu";
import {MatIconModule} from "@angular/material/icon";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {RouterModule} from "@angular/router";
import {MillionFormatPipe} from "../../pipes/million-format.pipe";
import {TruncatePipe} from "../../pipes/truncate.pipe";
import {NumberCounterComponent} from "./general/number-counter/number-counter.component";
import {WeavePaginationComponent} from "../../shared/weave-pagination/weave-pagination.component";
import {OnlyActivePipe} from "../../pipes/only-active.pipe";
import {DndDirective} from "../../directives/dnd.directive";
import {SafeHtmlPipe} from "../../pipes/safe-html.pipe";
import {SafeUrlPipe} from "../../pipes/safe-url.pipe";
import {
  SourcesFilterPipe
} from "../assessment/assessment-workspace/assessment-goals/assessment-objectives/assessment-measures/sources-filter.pipe";
import {SearchedUserPipe} from "./team-users/member-search/searched-user.pipe";
import {MemberComponent} from "./team-users/member/member.component";
import {MemberAddComponent} from "./team-users/member-add/member-add.component";
import {MemberGroupComponent} from "./team-users/member-group/member-group.component";
import {MemberSearchComponent} from "./team-users/member-search/member-search.component";
import {TeamUsersComponent} from "./team-users/team-users.component";
import {SnackbarComponent} from "./snackbar/snackbar.component";
import {UploadComponent} from "../../shared/warning-popups/upload/upload.component";
import {SideNavPaneComponent} from "./side-nav-pane/side-nav-pane.component";
import {MatSelectModule} from "@angular/material/select";
import {AutofocusDirective} from "../../shared/autofocus.directive";
import {ImageCropperComponent} from "ngx-image-cropper";
import {NgScrollbarModule} from "ngx-scrollbar";
import {WeaveInputComponent} from "../../shared/forms/weave-input/weave-input.component";
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { MatInput } from "@angular/material/input";
import { MatRadioButton, MatRadioGroup } from "@angular/material/radio";
import {RequireTldDirective} from "../../shared/forms/require-tld.directive";
import {
  MatExpansionPanel,
  MatExpansionPanelContent,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import { MatCheckbox } from "@angular/material/checkbox";
import { WeaveInputAutocompleteComponent} from "../../shared/forms/weave-input-autocomplete/weave-input-autocomplete.component";
import { MatAutocomplete, MatAutocompleteTrigger } from "@angular/material/autocomplete";


@NgModule({
  imports: [
    BlockUIModule.forRoot( {
      template: WeaveLoaderComponent,
    } ),
    CommonModule,
    FormsModule,
    MatIconModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatMenuModule,
    RouterModule,
    MatSelectModule,
    ImageCropperComponent,
    NgScrollbarModule,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatDialogClose,
    MatInput,
    MatRadioButton,
    MatRadioGroup,
    NgOptimizedImage,
    RequireTldDirective,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatCheckbox,
    MatExpansionPanelContent,
    MatAutocomplete,
    ReactiveFormsModule,
    MatAutocompleteTrigger,
  ],
  declarations: [
      KeysPipe,
      ProgressBarComponent,
      UserAvatarComponent,
      FooterComponent,
      FooterResponsiveComponent,
      MillionFormatPipe,
      TruncatePipe,
      OnlyActivePipe,
      NumberCounterComponent,
      WeavePaginationComponent,
      DndDirective,
      SafeHtmlPipe,
      SafeUrlPipe,
      SourcesFilterPipe,
      SearchedUserPipe,
      MemberComponent,
      MemberAddComponent,
      MemberGroupComponent,
      MemberSearchComponent,
      TeamUsersComponent,
      SnackbarComponent,
      UploadComponent,
      SideNavPaneComponent,
      AutofocusDirective,
      WeaveInputComponent,
      WeaveInputAutocompleteComponent
  ],
    exports: [
        /*PerfectScrollbarModule,*/
        KeysPipe,
        ProgressBarComponent,
        UserAvatarComponent,
        FooterComponent,
        FooterResponsiveComponent,
        MillionFormatPipe,
        TruncatePipe,
        NumberCounterComponent,
        WeavePaginationComponent,
        OnlyActivePipe,
        DndDirective,
        SafeHtmlPipe,
        SafeUrlPipe,
        SourcesFilterPipe,
        SearchedUserPipe,
        MemberComponent,
        MemberAddComponent,
        MemberGroupComponent,
        MemberSearchComponent,
        TeamUsersComponent,
        SnackbarComponent,
        UploadComponent,
        SideNavPaneComponent,
        AutofocusDirective,
        WeaveInputComponent,
        WeaveInputAutocompleteComponent
    ],
  providers: [
    SearchedUserPipe,
    DatePipe,
  ]
})
export class SharedModule { }
